import Button from "@mui/material/Button";
import Testo from "../elementi/Testo";
import { monFetch } from "../inc/inc";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const Comp = (props) => {
  let params = useParams();

  let id = params.id;

  const [sezioni, setSezioni] = useState([]);
  const [optionsSezioni, setOptionsSezioni] = useState([]);
  const [optionsIndustry, setOptionsIndustry] = useState([]);

  const [ragioneSociale, setRagioneSociale] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [cap, setCap] = useState("");
  const [citta, setCitta] = useState("");
  const [provincia, setProvincia] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [pec, setPec] = useState("");
  const [piva, setPiva] = useState("");
  const [cf, setCf] = useState("");
  const [sdi, setSdi] = useState("");
  const [companyIndustryId, setCompanyIndustryId] = useState(null);

  const [nomeRappresentante, setNomeRappresentante] = useState("");
  const [telefonoRappresentante, setTelefonoRappresentante] = useState("");
  const [cellulareRappresentante, setCellulareRappresentante] = useState("");
  const [emailRappresentante, setEmailRappresentante] = useState("");

  const [nomeAmministrativo, setNomeAmministrativo] = useState("");
  const [telefonoAmministrativo, setTelefonoAmministrativo] = useState("");
  const [cellulareAmministrativo, setCellulareAmministrativo] = useState("");
  const [emailAmministrativo, setEmailAmministrativo] = useState("");

  const [nomeTecnico, setNomeTecnico] = useState("");
  const [telefonoTecnico, setTelefonoTecnico] = useState("");
  const [cellulareTecnico, setCellulareTecnico] = useState("");
  const [emailTecnico, setEmailTecnico] = useState("");

  async function queryCliente(id) {
    const res = await monFetch("/customerGet", {
      id: id,
    });
    const cliente = res.customer;
    setSezioni(cliente.customer_sections);

    setRagioneSociale(cliente.businessName);
    setIndirizzo(cliente.address);
    setCap(cliente.zip);
    setCitta(cliente.city);
    setProvincia(cliente.state);
    setTelefono(cliente.telephone);
    setEmail(cliente.email);
    setPec(cliente.pec);
    setPiva(cliente.piva);
    setCf(cliente.cf);
    setSdi(cliente.sdi);
    setCompanyIndustryId(cliente.company_industry_id)

    setNomeRappresentante(cliente.attorneyName);
    setTelefonoRappresentante(cliente.attorneyTelephone);
    setCellulareRappresentante(cliente.attorneyMobile);
    setEmailRappresentante(cliente.attorneyEmail);

    setNomeAmministrativo(cliente.administrativeName);
    setTelefonoAmministrativo(cliente.administrativeTelephone);
    setCellulareAmministrativo(cliente.administrativeMobile);
    setEmailAmministrativo(cliente.administrativeEmail);

    setNomeTecnico(cliente.technicalName);
    setTelefonoTecnico(cliente.technicalTelephone);
    setCellulareTecnico(cliente.technicalMobile);
    setEmailTecnico(cliente.technicalEmail);
  }

  async function salvaCliente(e) {
    e.preventDefault();

    // console.log(password);
    // return
    const res = await monFetch("/customerSet", {
      id: id,
      sections: sezioni,

      businessName: ragioneSociale,
      address: indirizzo,
      zip: cap,
      city: citta,
      state: provincia,
      telephone: telefono,
      email: email,
      pec: pec,
      piva: piva,
      cf: cf,
      sdi: sdi,
      company_industry_id: companyIndustryId,

      attorneyName: nomeRappresentante,
      attorneyTelephone: telefonoRappresentante,
      attorneyMobile: cellulareRappresentante,
      attorneyEmail: emailRappresentante,

      administrativeName: nomeAmministrativo,
      administrativeTelephone: telefonoAmministrativo,
      administrativeMobile: cellulareAmministrativo,
      administrativeEmail: emailAmministrativo,

      technicalName: nomeTecnico,
      technicalTelephone: telefonoTecnico,
      technicalMobile: cellulareTecnico,
      technicalEmail: emailTecnico,
    });
    // console.log(res);

    if (res.success) {
      if (res.id) {
        window.location.href = process.env.PUBLIC_URL + "/clienti";
      } else {
        window.location.href = process.env.PUBLIC_URL + "/clienti";
      }
    }
  }

  async function querySezioni(e) {
    const res = await monFetch("/sectionListFiltered", {});

    const temp = [];
    res.section.forEach((el) => {
      temp.push({
        label: el.name,
        value: el.id,
      });
    });
    setOptionsSezioni(temp);
  }

  async function queryIndustry(e) {
    const res = await monFetch("/industryList", {});
    // console.log(res);

    const temp = [];
    temp.push({
      label: "---",
      value: null,
    });
    res.company_industry.forEach((el) => {
      temp.push({
        label: el.description,
        value: el.id,
      });
    });
    setOptionsIndustry(temp);
  }


  useEffect(() => {
    props.setTestoTitolo(props.nuovo ? "Aggiungi Cliente" : "Modifica Cliente");

    querySezioni();
    queryIndustry();

    if (id) {
      queryCliente(id);
    }
  }, []);

  return (
    <form onSubmit={(e) => salvaCliente(e)}>
      <Grid container spacing={0} className="sectionBar">
        <Grid item sm={12} xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel>Sezioni</InputLabel>
            <Select
              multiple
              fullWidth
              label="Sezioni"
              value={sezioni || ""}
              onChange={(e) => {
                setSezioni(e.target.value);
              }}
            >
              {optionsSezioni.map((el) => (
                <MenuItem key={el.value} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="paddingSez">
        <Grid item sm={12} xs={12}>
          <Testo
            required
            label="Ragione sociale"
            value={ragioneSociale || ""}
            onChange={(e) => {
              setRagioneSociale(e.target.value);
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <Testo
            required
            label="Indirizzo"
            value={indirizzo || ""}
            onChange={(e) => {
              setIndirizzo(e.target.value);
            }}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Testo
            required
            label="Cap"
            value={cap || ""}
            onChange={(e) => {
              setCap(e.target.value);
            }}
            inputProps={{
              maxLength: 5,
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Testo
            required
            label="Citta"
            value={citta || ""}
            onChange={(e) => {
              setCitta(e.target.value);
            }}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Testo
            required
            label="Provincia"
            value={provincia || ""}
            onChange={(e) => {
              setProvincia(e.target.value);
            }}
            inputProps={{
              maxLength: 2,
            }}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            required
            label="Telefono"
            value={telefono || ""}
            onChange={(e) => {
              setTelefono(e.target.value);
            }}
            inputProps={{
              maxLength: 15,
            }}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            required
            label="Email"
            value={email || ""}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            required
            label="PEC"
            value={pec || ""}
            onChange={(e) => {
              setPec(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            required
            label="P.IVA"
            value={piva || ""}
            onChange={(e) => {
              setPiva(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            required
            label="C.F."
            value={cf || ""}
            onChange={(e) => {
              setCf(e.target.value);
            }}
            inputProps={{
              maxLength: 16,
            }}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            required
            label="SDI"
            value={sdi || ""}
            onChange={(e) => {
              setSdi(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <FormControl required fullWidth size="small">
            <InputLabel>Tipo Industria</InputLabel>
            <Select
             
              fullWidth
              label="Tipo Industria"
              value={companyIndustryId || ""}
              onChange={(e) => {
                setCompanyIndustryId(e.target.value);
              }}
            >
              {optionsIndustry.map((el) => (
                <MenuItem key={el.value} value={el.value}>
                  {el.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container item sm={12} xs={12} spacing={2} className="paddingSez">
        <Grid item sm={12} xs={12}>
          <Testo
            required
            label="Rappresentante Legale (nome e cognome)"
            value={nomeRappresentante || ""}
            onChange={(e) => {
              setNomeRappresentante(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>

        <Grid item sm={4} xs={12}>
          <Testo
            label="Telefono rappresentante legale"
            value={telefonoRappresentante || ""}
            onChange={(e) => {
              setTelefonoRappresentante(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Cellulare rappresentante legale"
            value={cellulareRappresentante || ""}
            onChange={(e) => {
              setCellulareRappresentante(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Email rappresentante legale"
            value={emailRappresentante || ""}
            onChange={(e) => {
              setEmailRappresentante(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
      </Grid>

      <Grid container item sm={12} xs={12} spacing={2} className="paddingSez">
        <Grid item sm={12} xs={12}>
          <Testo
            required
            label="Riferimento Amministrativo (nome e cognome)"
            value={nomeAmministrativo || ""}
            onChange={(e) => {
              setNomeAmministrativo(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>

        <Grid item sm={4} xs={12}>
          <Testo
            label="Telefono riferimento amministrativo"
            value={telefonoAmministrativo || ""}
            onChange={(e) => {
              setTelefonoAmministrativo(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Cellulare riferimento amministrativo"
            value={cellulareAmministrativo || ""}
            onChange={(e) => {
              setCellulareAmministrativo(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Email riferimento amministrativo"
            value={emailAmministrativo || ""}
            onChange={(e) => {
              setEmailAmministrativo(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
      </Grid>

      <Grid container item sm={12} xs={12} spacing={2} className="paddingSez">
        <Grid item sm={12} xs={12}>
          <Testo
            required
            label="Riferimento Tecnico (nome e cognome)"
            value={nomeTecnico || ""}
            onChange={(e) => {
              setNomeTecnico(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>

        <Grid item sm={4} xs={12}>
          <Testo
            label="Telefono riferimento tecnico"
            value={telefonoTecnico || ""}
            onChange={(e) => {
              setTelefonoTecnico(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>

        <Grid item sm={4} xs={12}>
          <Testo
            label="Cellulare riferimento tecnico"
            value={cellulareTecnico || ""}
            onChange={(e) => {
              setCellulareTecnico(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Testo
            label="Email"
            value={emailTecnico || ""}
            onChange={(e) => {
              setEmailTecnico(e.target.value);
            }}
            inputProps={{}}
          />
        </Grid>
      </Grid>

      <Grid item sm={12} xs={12}>
        <div className="flexSpaceBetween paddingSez">
          <Button
            className="buttonIndietro"
            href={process.env.PUBLIC_URL + "/clienti"}
            variant="contained"
          >
            Indietro
          </Button>
          <Button className="buttonSalva" type="submit" variant="contained">
            Salva
          </Button>
        </div>
      </Grid>
    </form>
  );
};

export default Comp;
